import React from 'react';
import ReactDOM from "react-dom";
import MaterialTable from 'material-table';
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';

export default class PurchaseDataTable extends React.Component {
  constructor(props) {
    super(props);
    this.theme = createMuiTheme({
      palette: {
        primary: {
          main: '#7cb342',
        },
        secondary: {
          main: '#4caf50',
        },
      },
    });
    this.state = {
      columns: [
        { title: 'Profile', field: 'profile', editable: 'never', grouping: false },
        { title: 'Purchaseable', field: 'purchaseable_name', editable: 'never' },
        { title: 'Hospital', field: 'hospital', editable: 'never' },
        { title: 'Amount', field: 'amount', editable: 'never', grouping: false },
        { title: 'Invoice Status', field: 'invoice_status'},
        { title: 'Payment', field: 'payment_type'},
        { title: 'Date', field: 'date', editable: 'never', grouping: false },
      ],
      data: [],
      page: null,
      totalCount: null
    }
    this.tableRef = React.createRef();
  }

  render () {
    return (
      <MuiThemeProvider theme={this.theme}>
        <MaterialTable
          title="Purchases"
          tableRef={this.tableRef}
          columns={this.state.columns}
          data={query =>
            new Promise((resolve, reject) => {
              let url = `/api/purchases.json?`
              // console.log('params', query)
              url += 'per_page=' + query.pageSize
              url += '&q=' + query.search
              url += '&page=' + (query.page + 1)
              if (this.props.profile_ids) {
                url += '&profile_ids=' + this.props.profile_ids
              }
              fetch(url)
                .then(response => response.json())
                .then(result => {
                  // console.log('row data', result.accounts.data)
                  resolve({
                    data: result.purchases,
                    page: result.pagination.page - 1,
                    totalCount: result.pagination.count,
                  })
                })
            })
          }

          actions={[
            {
              icon: 'refresh',
              tooltip: 'Refresh Data',
              isFreeAction: true,
              onClick: () => this.tableRef.current && this.tableRef.current.onQueryChange(),
            }
          ]}
          options={{
            pageSize: 10,
            pageSizeOptions: [10, 100, 200, 300, 500],
            exportButton: true,
            sorting: true,
            search: true,
            grouping: true,
            actionsColumnIndex: -1
          }}
          onRowClick={(event, rowData) => Turbolinks.visit(rowData.profile_url)}
        />
      </MuiThemeProvider>

    );
  }

}

